export default "__VITE_ASSET__Beg6d8lk__"